import styled from 'styled-components';


export const TableContainer = styled.div`
  overflow: scroll;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  z-index: 10;
  min-width: 600px;
  max-height: 400px;
  margin-top: 12px;

 @media screen and (max-width: 490px){
    max-width: 95%;
    min-width: 0;
  }
`;

export const ColWrapper = styled.div`
  overflow: scroll;
  display: flex;
  flex-direction: column;
  justify-content: top;
  align-items: center;
  z-index: 10;
  max-height: 400px;

 @media screen and (max-width: 490px){
    max-width:95%;
  }
`;

export const FormH1 = styled.div`
  color: #cc8f2d;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  margin-top: 24px;
  margin-bottom: 5px;

 @media screen and (max-width: 490px){
  font-size: 8px;
    text-align: center;
    margin-left: 6px;
    margin-top: 6px;
    margin-bottom: 6px;
  }
`;

export const ListHeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const ListItemContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const ListItem = styled.div`
  color: white;
  font-size: 14px;
  letter-spacing: 1.4px;
  text-align: center;
  
 @media screen and (max-width: 490px){
    text-align: center;
    font-size: 8px;
    margin-left: 6px;
    margin-top: 6px;
    margin-bottom: 6px;
  }
`;

export const ListRow = styled.div`
  background: linear-gradient(
    112deg,
    rgb(35, 36, 40) 0%,
    #cc8f2d 120%
  );
  display: flex;
  margin: 2px;
  border-radius: 12px;
  flex-direction: row;
  align-items: center;
  height: 60px;
  width: 300px;

  @media screen and ((max-width: 490px) ) {
    height: 50px;
    max-width:100%;
  }
`;

export const ListRowPort = styled.div`
  background: linear-gradient(
    112deg,
    #000 0%,
    rgb(35, 36, 40) 100%
  );
  display: flex;
  margin: 2px;
  border-radius: 12px;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  height: 60px;
  width: 300px;

  @media screen and ((max-width: 490px) ) {
    height: 50px;
    max-width:100%;
  }
`;

export const RowIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  align-text: middle;
  font-size: 12px;
  border-radius: 12px;
  background: #cc8f2d;
  color: black;
  width: 50px;
  height: 50px;

 @media screen and (max-width: 490px){
    font-size: 10px;
  width: 40px;
  height: 40px;
  }
`;

export const RowH1 = styled.div`
  display: flex;
  align-self: start;
  color: black;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  margin-top: 6px;
  margin-bottom: 5px;
  min-width: 100px;
  justify-content: center;

 @media screen and (max-width: 490px){
    flex-direction: row;
    overflow: scroll;
    max-width: 112px;
    font-size: 10px;
    margin-top: 6px;
    margin-bottom: 6px;
  }
`;

export const RowH2 = styled.div`
  display: flex;
  align-self: start;
  color: black;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  margin-top: 6px;
  margin-bottom: 5px;
  min-width: 100px;
  justify-content: center;

 @media screen and (max-width: 490px){
    flex-direction: row;
    max-width: 65%;
    font-size: 8px;
    margin-top: 6px;
    margin-bottom: 6px;
    
    /* Crucial additions for horizontal scrolling */
    overflow-x: auto;
    padding-right: 4px; 
    white-space: nowrap;
    justify-content: flex-start; /* Keeps text aligned left so you can scroll right */
    
    /* Optional: Hides the ugly scrollbar on mobile while keeping the touch scroll functionality */
    &::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
  }
`;

export const RowInfoStack = styled.div`
 display:flex;
 flex-direction: column;
 min-width: 100px;
 align-content: center;
`;

export const ToolTipContainer = styled.div`
  position: absolute;
  top: ${({ top }) => top};
  right: ${({ right }) => right};
  justify-content: center;
  background: black;
  border-radius: 4px;
  max-width: 200px;
  padding: 10px;
  z-index: 98;
  
  @media screen and (max-width: 1090px){
    right: 40px;
    max-width: 120px;
  }
 @media screen and (max-width: 490px){
    right: ${({ rightMobile }) => rightMobile};
    max-width: 70px;
    font-size: 10px;
  }
`;

export const ToolTipTopLine = styled.div`
  justify-content: center;
  text-align: left;
  color: #cc8f2d;
  margin-bottom: 10px;
  
 @media screen and (max-width: 490px){
    right: 10px;
    font-size: 10px;
  }
`;

export const ToolTipP = styled.div`
  justify-content: center;
  color: #ffffff;
  border-bottom: 2px solid white;
  text-align: left;
  
 @media screen and (max-width: 490px){
    right: 10px;
    font-size: 10px;
  }
`;
export const ToolTipFooter = styled.div`
  color: #cc8f2d;
  text-align: right;
  
 @media screen and (max-width: 490px){
    right: 10px;
    font-size: 10px;
  }
`;

export const ToolTipPointer = styled.div`
  position: absolute;
  top: ${({ top }) => top};
  right: ${({ right }) => right};
  height: 0; 
  width: 0;
  border-right: 12px solid black;
  border-top: 14px solid transparent;
  border-bottom: 14px solid transparent;
  z-index: 99;
  
 
 @media screen and (max-width: 490px){
    max-width: 80px;
    right:${({ rightM }) => rightM};
    top:${({ topM }) => topM};
    font-size: 10px;
    border-left: none;
    border-right: 12px solid black;
    z-index: 97;
  }
`;
